var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLiveData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.208 38C110.208 43.225 105.895 47.5 100.624 47.5C99.7619 47.5 98.9473 47.405 98.1806 47.1675L81.1223 64.03C81.3619 64.79 81.4577 65.645 81.4577 66.5C81.4577 71.725 77.1452 76 71.8744 76C66.6035 76 62.291 71.725 62.291 66.5C62.291 65.645 62.3869 64.79 62.6264 64.03L50.4077 51.9175C49.641 52.155 48.7785 52.25 47.916 52.25C47.0535 52.25 46.191 52.155 45.4243 51.9175L23.6223 73.5775C23.8618 74.3375 23.9577 75.145 23.9577 76C23.9577 81.225 19.6452 85.5 14.3743 85.5C9.10352 85.5 4.79102 81.225 4.79102 76C4.79102 70.775 9.10352 66.5 14.3743 66.5C15.2368 66.5 16.0514 66.595 16.8181 66.8325L38.6681 45.22C38.4285 44.46 38.3327 43.605 38.3327 42.75C38.3327 37.525 42.6452 33.25 47.916 33.25C53.1869 33.25 57.4994 37.525 57.4994 42.75C57.4994 43.605 57.4035 44.46 57.1639 45.22L69.3827 57.3325C70.1494 57.095 71.0119 57 71.8744 57C72.7369 57 73.5994 57.095 74.366 57.3325L91.3764 40.4225C91.1369 39.6625 91.041 38.855 91.041 38C91.041 32.775 95.3535 28.5 100.624 28.5C105.895 28.5 110.208 32.775 110.208 38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiveData);
export default __webpack_public_path__ + "static/media/iconLiveData.5d43fb318a5a3ad6328dca6fc96e0f5b.svg";
export { ForwardRef as ReactComponent };